<div class="cig-claim inner">
  
  <div class="box cig-controls">
    <p class="bold">$CIGSTR is currently holding</p>
    <p class="title gold-title">22.878 ETH + 5 {{ environment.tokenName }}s</p>

    <!-- Progress to Next Purchase -->
    <div class="progress-section">
      <p class="bold">Progress to Next Purchase: {{ purchaseProgress | number:'1.0-0' }}% • 0.1664 ETH remaining</p>
      <div class="progress-wrapper">
        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="purchaseProgress"></div>
        </div>
      </div>
    </div>    
  </div>
  

  <!-- Market Data Boxes Grid -->
  <div class="box market-data-grid">
    <h2 class="gold-title">Market Data</h2>
    
    <div class="market-stats-grid">
      <!-- ETH Price Box -->
      <div class="market-stat-box">
        <div class="stat-label">ETH PRICE</div>
        <div class="stat-value">{{ ethPrice }}</div>
        <div class="stat-change">—</div>
      </div>

      <!-- CIG Price Box -->
      <div class="market-stat-box">
        <div class="stat-label">CIG PRICE</div>
        <div class="stat-value">{{ cigPrice }}</div>
        <div class="stat-change" [ngClass]="cigPriceChangeClass">
          <span *ngIf="marketData">{{ cigPriceChange >= 0 ? '+' : '' }}{{ cigPriceChange | number:'1.2-2' }}%</span>
          <span *ngIf="!marketData">—</span>
        </div>
      </div>

      <!-- Market Cap Box -->
      <div class="market-stat-box">
        <div class="stat-label">MARKET CAP</div>
        <div class="stat-value">{{ marketCap }}</div>
      </div>

      <!-- 24H Volume Box -->
      <div class="market-stat-box">
        <div class="stat-label">24H VOLUME</div>
        <div class="stat-value">{{ volume24h }}</div>
      </div>

      <!-- Token Burnt Box -->
      <div class="market-stat-box">
        <div class="stat-label">TOKEN BURNT</div>
        <div class="stat-value">--</div>
      </div>

      <!-- Total NFTs Bought Box -->
      <div class="market-stat-box">
        <div class="stat-label">TOTAL NFTS BOUGHT</div>
        <div class="stat-value">5</div>
      </div>

      <!-- Total Sold Box -->
      <div class="market-stat-box">
        <div class="stat-label">TOTAL SOLD</div>
        <div class="stat-value">0</div>
      </div>

      <!-- Average Buy Price Box -->
      <div class="market-stat-box">
        <div class="stat-label">AVG BUY PRICE</div>
        <div class="stat-value">0.20153 ETH</div>
      </div>

      <!-- Treasury ETH Box -->
      <div class="market-stat-box">
        <div class="stat-label">TREASURY ETH</div>
        <div class="stat-value">0.0336381 ETH</div>
      </div>

      <!-- Total Profit Box -->
      <div class="market-stat-box">
        <div class="stat-label">TOTAL PROFIT</div>
        <div class="stat-value negative">-1.00765 ETH</div>
      </div>
    </div>


  </div>

 
  <!-- Action Boxes -->
  <div class="action-boxes-grid">
    <!-- Buy NFT for Protocol Box -->
    <div class="box action-box">
      <h3 class="action-title">FLOOR PUNK</h3>
      <div class="action-content">
        <div class="nft-preview">
          <img
            [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + '1128.svg'"
            [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
            width="100" height="100"
            alt="Target NFT"
          />
        </div>
        <div class="action-details">
          <div class="detail-row">
            <span class="detail-label">Target NFT:</span>
            <span class="detail-value">#11928</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Price:</span>
            <span class="detail-value">0.2000 ETH</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Available:</span>
            <span class="detail-value">0.0336381 ETH</span>
          </div>
        </div>
        <button 
          *ngIf="!isConnected" 
          class="retro action-button" 
          (click)="connect()"
        >
          CONNECT WALLET TO BUY
        </button>
        <button 
          *ngIf="isConnected" 
          class="retro action-button" 
          (click)="buyNftForProtocol()"
        >
          BUY
        </button>
      </div>
    </div>

    <!-- Burn CIG Box -->
    <div class="box action-box">
      <h3 class="action-title">BURN $CIG</h3>
      <div class="action-content">
        <div class="burn-details">
          <div class="detail-row">
            <span class="detail-label">Burn:</span>
            <span class="detail-value">...</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Reward:</span>
            <span class="detail-value">...</span>
          </div>
        </div>
        <button 
          *ngIf="!isConnected" 
          class="retro action-button" 
          (click)="connect()"
        >
          CONNECT WALLET
        </button>
        <button 
          *ngIf="isConnected" 
          class="retro action-button" 
          (click)="burnCig()"
        >
          BURN $CIG
        </button>

        <!-- Donation summary (static design; aligned with detail rows) -->
        <div class="donation-summary burn-details">
          <div class="detail-row">
            <span class="detail-label">Donation</span>
            <span class="detail-value">NODE Foundation</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Total donated:</span>
            <span class="detail-value">2.3276 <span class="unit">ETH</span></span>
          </div>
        </div>
      </div>
    </div>
  </div> 

  <!-- Listings Offered to CIG Protocol Box -->
  <div class="box">
    <h2 class="gold-title">
      LISTINGS OFFERED TO $CIGSTR
      <span
        class="info"
        tippy
        [options]="{ content: 'NFTs currently being offered for purchase to the protocol.', placement: 'bottom', interactive: true }"
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg> 
      </span>
    </h2>
    
    <div class="listings-container" *ngIf="listingsOfferedToCEO?.length; else noListings">
      <div class="listing-item" *ngFor="let listing of listingsOfferedToCEO">
        <div class="listing-content">
          <div class="listing-preview">
            <img
              [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (listing.punk?.id | tokenIdParse) + '.svg'"
              [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
              width="100" height="100"
              alt="NFT"
            />
          </div>
          <div class="listing-details">
            <div class="detail-row">
              <span class="detail-label">NFT:</span>
              <span class="detail-value">{{ environment.tokenName }} #{{ listing.punk?.id }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Price:</span>
              <span class="detail-value">{{ (listing.value | weiToEth) | formatCash }} ETH</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">From:</span>
              <span class="detail-value">
                <app-wallet-address [address]="listing.fromAccount?.id"></app-wallet-address>
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Date:</span>
              <span class="detail-value">{{ listing.blockTimestamp | timestamp:'short' }}</span>
            </div>
          </div>
          <button 
            class="retro action-button accept-button" 
            (click)="acceptListing(listing)"
            [disabled]="acceptingListing"
          >
            ACCEPT & BUY
          </button>
        </div>
      </div>
    </div>
    
    <ng-template #noListings>
      <div class="no-listings">
        <p>No listings currently offered to the CIG protocol.</p>
      </div>
    </ng-template>
  </div>


  <div class="box cig-controls">
    <h2 class="gold-title">CigStr CEO powered by $CIG token</h2>

    <div class="row">
      <!-- Punk image (CEO) on the left -->
      <div>
        <div class="thumb item ceo image-wrapper" *ngIf="cigStatsDto?.ceoTokenId !== null; else unknownCeoImg">
          <img
            [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (cigStatsDto!.ceoTokenId! | tokenIdParse) + '.svg'"
            [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
            width="100" height="100"
            alt="Current CEO Punk"
          />
        </div>
        
        <div class="ceo-connect-section" *ngIf="!isConnected">
          <button class="retro action-button ceo-connect-btn" (click)="connect()">
            CONNECT WALLET
          </button>
        </div>
      
        <div class="ceo-connect-section" *ngIf="isConnected">
          <button class="retro action-button ceo-connect-btn" (click)="openTakeover()">
            TAKE OVER
          </button>
        </div>
      </div>
      
      <ng-template #unknownCeoImg>
        <div class="thumb item">
          <img
            [lazyLoad]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
            width="100" height="100"
            alt="Unknown CEO"
          />
        </div>
      </ng-template>
      <!-- Text on the right -->
      <div class="meta">
        <div class="meta-grid">
          <div class="label">Current CEO</div>
          <div class="value">
            <span *ngIf="cigStatsDto?.ceoTokenId !== null; else unknownCeo">Punk #{{ cigStatsDto?.ceoTokenId }}</span>
            <ng-template #unknownCeo>Unknown</ng-template>
          </div>

          <ng-container *ngIf="cigStatsDto?.ceoWallet as wallet">
            <div class="label">CEO Wallet</div>
            <div class="value">
              <a [href]="'https://etherscan.io/address/' + wallet" target="_blank">
                <app-wallet-address [address]="wallet"></app-wallet-address>
              </a>
            </div>
          </ng-container>

          <ng-container *ngIf="cigStatsDto?.takeOverPrice !== null">
            <div class="label">Takeover price</div>
            <div class="value">
              {{ (cigStatsDto!.takeOverPrice!.toString() | weiToEth) | formatCash }} $CIG 
            </div>
          </ng-container>

          <ng-container *ngIf="cigStatsDto?.takePrepaid !== null">
            <div class="label">Tax prepaid</div>
            <div class="value">
              {{ (cigStatsDto!.takePrepaid!.toString() | weiToEth) | formatCash }} $CIG 
            </div>
          </ng-container>

          <ng-container *ngIf="cigStatsDto?.graffiti as g">
            <div class="label">Graffiti</div>
            <div class="value"><span>{{ g }}</span></div>
          </ng-container>
        </div>

        <p>
          The CEO is the current leader of the $CIG claim event. This punk represents the top claimant or a special role in the airdrop process. Stay tuned for updates and check if your punk can take the lead!
        </p>
      </div>
    </div>
  </div>

  <!-- Fee Splits Box -->
  <div class="box">
    <h2 class="gold-title">FEE SPLITS</h2>
    
    <div class="fee-splits enhanced">
      <div class="chart">
        <div class="chart-box">
        <app-pie-chart
          [slices]="taxBreakdownSlices"
          [innerSlices]="overallTaxSlices"
          [autoSize]="true"
          [thickness]="25"
          [innerThickness]="20"
          [ringGap]="25"
          [outerAlignToInnerLabel]="'Overall Tax'"
          [zoomCircleFraction]="0.12"
          [showZoomConnectors]="true"
          connectorColor="#bbbbbb"
          [connectorWidth]="1"
          [cropToZoomedOuterSlice]="true"
          [viewportPadding]="12"
          [animateOnAppear]="true"
          [animationDuration]="700"
          [animationStagger]="150"
        ></app-pie-chart>
        </div>

        <button
          *ngIf="isConnected"
          class="retro action-button"
          (click)="openTakeover()"
        >
          CHANGE SPLITS
        </button>            

        <button 
          *ngIf="!isConnected" 
          class="retro action-button" 
          (click)="connect()"
        >
          CONNECT WALLET
        </button>
      </div>
      <div class="legend">
        <!-- Overall Tax (inner ring) -->
        <div class="legend-item">
          <span class="dot overall"></span>
          <span class="name">Protocol Tax</span>
          <span class="spacer"></span>
          <span class="val">{{ overallTaxPercent | number:'1.0-0' }}%</span>
        </div>
        <!-- Breakdown (outer ring), indented -->
        <div class="legend-item sub">
          <span class="dot main"></span>
          <span class="name">Protocol Treasury</span>
          <span class="spacer"></span>
          <span class="val">{{ mainRelPercent | number:'1.0-0' }}% <small>({{ mainAbsPercent | number:'1.0-0' }}% total)</small></span>
        </div>
        <div class="legend-item sub">
          <span class="dot burn"></span>
          <span class="name">CIG Burn (or donation)</span>
          <span class="spacer"></span>
          <span class="val">{{ feeSplits.cigBurnSplit | number:'1.0-0' }}% <small>({{ burnAbsPercent | number:'1.0-0' }}% total)</small></span>
        </div>
        <div class="legend-item sub">
          <span class="dot dev"></span>
          <span class="name">Developer fee</span>
          <span class="spacer"></span>
          <span class="val">{{ feeSplits.devSplit | number:'1.0-0' }}% <small>({{ devAbsPercent | number:'1.0-0' }}% total)</small></span>
        </div>
        <div class="legend-item sub">
          <span class="dot ceo"></span>
          <span class="name">CEO fee</span>
          <span class="spacer"></span>
          <span class="val">{{ feeSplits.ceoSplit | number:'1.0-0' }}% <small>({{ ceoAbsPercent | number:'1.0-0' }}% total)</small></span>
        </div>
      </div>
    </div>
  </div>

<!-- Protocol-owned NFTs -->
<div class="box">
  <h2 class="gold-title">NFTs owned by $CIGSTR</h2>

  <div class="protocol-owned">
    <ng-container *ngIf="!loadingProtocolOwned && (protocolOwned?.length || 0) > 0; else protocolOwnedEmpty">
      <div class="grid">
        <div class="item" *ngFor="let it of protocolOwned; let i = index">
          <div class="item-inner">
            <a class="item-link" [routerLink]="['/', 'details', it.tokenId]" [attr.aria-label]="'View ' + environment.tokenName + ' #' + it.tokenId">
              <div class="image-wrapper">
                <img
                  [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (it.tokenId | tokenIdParse) + '.svg'"
                  [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
                  width="50"
                  height="50"
                />
              </div>
            </a>
            <div class="protocol-details">
              <div class="po-title">{{ environment.tokenName }} #{{ it.tokenId }}</div>
              <div class="po-price">
                {{ (it.boughtWei | weiToEth) | formatCash }} ETH
                <span class="usd">(${{ (((it.boughtWei | weiToEth) | usd : (dataSvc.usd$ | async)) || 0) | formatCash }})</span>
              </div>
              <div class="po-date">{{ (it.boughtAt * 1000) | timeago : true }}</div>
              <div class="po-list" *ngIf="it.listingWei">
                {{ (it.listingWei | weiToEth) | formatCash }} ETH
                <span class="usd">(${{ (((it.listingWei | weiToEth) | usd : (dataSvc.usd$ | async)) || 0) | formatCash }})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #protocolOwnedEmpty>
      <div class="empty" *ngIf="!loadingProtocolOwned">No purchases found yet.</div>
      <div class="empty" *ngIf="loadingProtocolOwned">Loading...</div>
    </ng-template>
  </div>
</div>

  <ng-container *ngIf="isConnected">
    <div class="box">    
      <h2 class="gold-title">$CIG AIRDROP CLAIM</h2>

      <div class="claim-container">
        <div class="claimable image-wrapper">
          <div class="per-token" *ngIf="perTokenAmounts?.length">


            <div class="row" *ngFor="let row of displayedTokens">
              <div class="thumb item">
                <img [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (row.tokenId | tokenIdParse) + '.svg'"
                  [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
                  width="160" height="160" />
              </div>
              <div class="meta">
                <div class="token">{{ environment.tokenName }} #{{ row.tokenId }}</div>
                <div class="amount"><slot-counter [number]="row.amount*1000"></slot-counter> <span class="unit">CIG</span>
                </div>
              </div>
            </div>
            
            <!-- Show "and XXX more tokens" message when there are more than 9 tokens -->
            <div class="row more-tokens-row" *ngIf="hasMoreTokens">

              <div class="meta">
                <div class="token more-tokens-label">...and {{ remainingTokensCount }} more tokens</div>
                <div class="amount">
                  <span class="more-tokens-amount">
                    <slot-counter [number]="remainingTokensAmount * 1000"></slot-counter>
                    <span class="unit">CIG</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="total-row">
              <div class="row">
                <div class="meta">
                  <div class="token total-label">Total</div>
                </div>
                <div class="amount">
                  <slot-counter [number]="claimable*1000"></slot-counter>
                  <span class="unit">CIG</span>
                </div>
              </div>

              <div class="actions">
                <button class="retro" (click)="claim()" [disabled]="!canClaim">CLAIM</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </ng-container>

  <div class="box">
    <iframe id="geckoterminal-embed" title="GeckoTerminal Embed" src="https://www.geckoterminal.com/eth/pools/0xc50673EDb3A7b94E8CAD8a7d4E0cD68864E33eDF?embed=1&amp;info=0&amp;swaps=0&amp;light_chart=0&amp;chart_type=price&amp;resolution=5m&amp;bg_color=111827" frameborder="0" allow="clipboard-write" allowfullscreen="" style="width:100%;height:100%;min-height: 500px;"></iframe>
  </div>

  <!-- TAKE OVER Modal -->
  <div class="modal-overlay" [class.active]="takeoverOpen">
    <div class="modal">
      <button class="close-modal" (click)="closeTakeover()">x</button>
      <h2 class="gold-title">BECOME THE CEO OF THE CRYPTOPUNKS</h2>

      <div class="form">
        <div class="form-group">
          <label>Your new price in Cigarettes (CIG)</label>
          <input type="number" min="1" step="1" [(ngModel)]="form.priceCig" (ngModelChange)="calculateTakeoverCosts()"/>
          <small>
            What price others have to pay to take you over? Choose carefully: high price costs more tax; low price is easier to be taken over.
          </small>
        </div>

        <div class="form-group">
          <label>New CEO Punk ID</label>
          <input type="number" min="0" step="1" [(ngModel)]="form.punkId"/>
          <small>That punk will be displayed as the CEO</small>
        </div>

        <div class="form-group">
          <label>The Punk Graffiti</label>
          <input type="text" maxlength="32" [(ngModel)]="form.graffiti"/>
          <small>A short message to display (max 32 characters)</small>
        </div>

        <div class="form-group">
          <label>Harberger Tax, days to pre-pay:</label>
          <input type="number" min="1" step="1" [(ngModel)]="form.days" (ngModelChange)="calculateTakeoverCosts()"/>
          <small>
            If the new price is {{ form.priceCig || 0 }}, then the tax per day is: {{ taxPerDayCig | number:'1.0-6' }} CIG
          </small>
        </div>

        <div class="total">
          Total cost: {{ totalCostCig | number:'1.0-6' }} CIG
        </div>
      </div>

      <div class="form-actions">
        <button class="cancel" (click)="closeTakeover()">Cancel</button>
        <button class="submit" [disabled]="buying" (click)="confirmTakeover()">Buy CEO Now</button>
      </div>

      <p>By interacting with this App, you agree to our <a [href]="'/assets/tos-' + environment.collection + '.pdf'" target="_blank">Terms of Use</a></p>

    </div>
  </div>

  <!-- Transaction Modal -->
  <div class="modal-overlay" [class.active]="isCigClaimTransactionActive && (txTrackingSvc.txModalActive$ | async)" [class.transaction]="isCigClaimTransactionActive && (txTrackingSvc.txModalActive$ | async)">
    <div class="modal">
      <ng-container *ngIf="isCigClaimTransactionActive && (txTrackingSvc.txModalActive$ | async)">
        <button class="close-modal" (click)="txTrackingSvc.closeTxModal(); isCigClaimTransactionActive = false">x</button>
  
        <ng-container *ngFor="let status of txTrackingSvc.txStatusArray; let i = index">
          <ng-container *ngIf="status.active">
  
            <h3>
              <img
                src="/assets/loader-{{ themeSvc.theme$ | async }}.gif"
                width="20" height="20"
                *ngIf="i === 0 || i === 1"
              />
              {{ status.title }}
            </h3>
            
            <span class="p-wrapper" [innerHTML]="status.message || ''"></span>
  
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

</div>